import { Dispatch, FC, SetStateAction } from 'react';
import {
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  Chip,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { get, isNil } from 'lodash';
import frLocale from 'date-fns/locale/fr';
import DateFnsUtils from '@date-io/date-fns';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { DATE_FORMAT, DOCUMENT_TYPES } from 'constants/global';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from 'moment';
import { injectIntl, IntlShape } from 'react-intl';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { translate, arrayTranslate } from 'containers/services/translate';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import expertiseExpertiseIcon from 'images/expert-expertise-icon.svg';
import { COLORS } from 'constants/design';
import { StyledGrid } from 'containers/ExpertExpertise/FillExpertise/style';
import messages from 'containers/ExpertExpertise/FillExpertise/messages';
import CustomSelect from 'containers/ExpertExpertise/FillExpertise/CustomSelect';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { JudgementOnMeritsDoc } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
} from 'containers/UploadDocuments/actions';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Expertise } from 'containers/ExpertExpertise/ConcernedExpertise/typings';
import { VictimType } from 'typings/globalTypes';
import { displayErrorText } from 'containers/services/validateForm';
import {
  DOCUMENT,
  MISSION_EXPERISE_VICTIM_STATUS,
  VICTIM_EXPERTISE_FIELDS,
} from 'containers/data-structure';
import Document from 'components/Document';
import { handleOpenDocument } from 'services/utils';
import {
  renderChipLabel,
  renderColor,
} from 'containers/ExpertExpertise/Recap/utils';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { MISSION_EXPERTISE_VICTIM_TYPE } from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import { isTransactionMission } from 'containers/CourtManagerAssignedExpertise/utils';
import ExpertRapportDocument from 'containers/ExpertExpertise/ConcernedExpertise/ExpertRapportDocument';

export interface FillExpertiseProps {
  intl: IntlShape;
  title: string;
  uploadDocument: Function;
  resetUploadDocumentStore: Function;
  setDocumentId: Function;
  uploadedDocument: IUploadedDocument;
  documentId: string;
  documentIdStore: string;
  formBody: Expertise;
  setFormBody: Dispatch<SetStateAction<Expertise>>;
  document: JudgementOnMeritsDoc;
  setDocument: Dispatch<SetStateAction<JudgementOnMeritsDoc>>;
  victim: VictimType;
  validateExpertise: any;
  validateDocumentExpertise: any;
  isReadOnly?: boolean;
  listings: any;
  sagis_code: any;
  mission: any;
  missionDate: any;
  setMissionDate: Function;
  requestGetDocByDocumentumId: Function;
  claimNumber: string;
  lossDate: Date;
}

const DeceasedVictimForm: FC<FillExpertiseProps> = (props): JSX.Element => {
  const {
    uploadDocument,
    resetUploadDocumentStore,
    setDocumentId,
    title,
    uploadedDocument,
    documentId,
    documentIdStore,
    formBody,
    setFormBody,
    document,
    setDocument,
    victim,
    validateDocumentExpertise,
    isReadOnly = false,
  } = props;
  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);

  const documentError = displayErrorText(
    validateDocumentExpertise,
    translateArrayErrorMessages(validateDocumentExpertise, true),
  );

  const handleDateChange = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const missionDate = moment(theDate as Date).format(DATE_FORMAT);

    props.setMissionDate(missionDate);
  };
  const setDoc = (document: CorporealDocument) => {
    if (!document.name && !document.type) {
      setDocument({
        ...document,
        url: document.url,
        response: document.url,
      } as any);

      resetUploadDocumentStore();
    } else if (documentId === documentIdStore) {
      setDocument({
        ...document,
        name: document.name,
        type: document.type,
        url: document.url,
      });
      resetUploadDocumentStore();
    }
  };

  const deleteDoc = () => {
    if (!get(document, 'response', null)) {
      setDocument({ ...document, response: '', url: '' } as any);
    }
    setDocument({ ...document, url: '' });
  };
  const handleChange = (fieldName: string) => (
    e: React.ChangeEvent<{ value: unknown; name?: string }>,
  ) => {
    const { value } = e.target;
    setFormBody({ ...formBody, [fieldName as string]: value });
  };
  const IsChecked = get(
    formBody,
    VICTIM_EXPERTISE_FIELDS.IS_DEATH_RELATED_TO_CLAIM,
    false,
  );

  const handleCheckBoxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;

    setFormBody({ ...formBody, [name as string]: checked });
  };
  const assignement = get(props.mission, 'assignedExperts').find(
    (element: any) => element.expertCode === props.sagis_code,
  );
  return (
    <>
      <CustomAccordion
        title={title}
        textColor={COLORS.ACCORDION_TEXT_BLUE}
        bgColor={COLORS.ACCORDION_BG_BLUE}
        image={expertiseExpertiseIcon}
      >
        <StyledGrid container spacing={3} alignItems="center">
          <Grid item xs={4}>
            <CustomSelect
              title={translate(messages.victim, props)}
              items={[
                { label: `${victim.firstName} ${victim.lastName}`, value: 1 },
              ]}
              value={1}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              title={
                assignement?.type ===
                  MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION &&
                get(formBody, 'createdBy', '') === props.sagis_code
                  ? translate(messages.commentAppreciation, props)
                  : translate(messages.comment, props)
              }
              label={
                assignement?.type ===
                  MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION &&
                get(formBody, 'createdBy', '') === props.sagis_code
                  ? translate(messages.commentAppreciation, props)
                  : translate(messages.comment, props)
              }
              value={formBody.comment}
              name="comment"
              onChange={handleChange('comment')}
              fullWidth
              InputProps={{
                disabled: isReadOnly,
              }}
            />
          </Grid>
          {isNil(get(props.mission, 'missionDate')) && (
            <Grid item>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  invalidDateMessage=""
                  format="dd/MM/yyyy"
                  id="lossDate"
                  onChange={handleDateChange}
                  name={'mission-date'}
                  value={dateStringToLocalDate(props.missionDate)}
                  label={translate({ ...messages.missionDate }, props)}
                  className="input"
                  error={props.missionDate === 'Invalid date'}
                  helperText={
                    props.missionDate === 'Invalid date'
                      ? translate(messages.invalidDate, props)
                      : ''
                  }
                />
              </MuiPickersUtilsProvider>
            </Grid>
          )}
          <Grid item xs={4}>
            <div className="spaceBloc">
              <FormControlLabel
                name={VICTIM_EXPERTISE_FIELDS.IS_DEATH_RELATED_TO_CLAIM}
                control={
                  <Checkbox
                    name={VICTIM_EXPERTISE_FIELDS.IS_DEATH_RELATED_TO_CLAIM}
                    checked={IsChecked}
                    onChange={handleCheckBoxChange}
                    color="primary"
                    disabled={isReadOnly}
                  />
                }
                label={translate(messages.isDeathRelatedToClaim, props)}
              />
            </div>
          </Grid>
          {featureService.hasFeature(FEATURES.TRANSACTION) && (
            <>
              <Grid item xs={6}>
                <TextField
                  title={translate(messages.certificatDescription, props)}
                  label={translate(messages.certificatDescription, props)}
                  value={formBody.certificatDescription}
                  onChange={handleChange('certificatDescription')}
                  fullWidth
                  InputProps={{
                    disabled: props.isReadOnly,
                  }}
                  inputProps={{
                    style: {
                      overflowY: 'auto',
                      height: 'auto',
                    },
                  }}
                  rows={6}
                  multiline
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  title={translate(messages.clinicalExamination, props)}
                  label={translate(messages.clinicalExamination, props)}
                  value={formBody.clinicalExamination}
                  onChange={handleChange('clinicalExamination')}
                  fullWidth
                  InputProps={{
                    disabled: props.isReadOnly,
                  }}
                  inputProps={{
                    style: {
                      overflowY: 'auto',
                      height: 'auto',
                    },
                  }}
                  rows={6}
                  multiline
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  title={translate(messages.injuryDescription, props)}
                  label={translate(messages.injuryDescription, props)}
                  value={formBody.injuryDescription}
                  onChange={handleChange('injuryDescription')}
                  fullWidth
                  InputProps={{
                    disabled: props.isReadOnly,
                  }}
                  inputProps={{
                    style: {
                      overflowY: 'auto',
                      height: 'auto',
                    },
                  }}
                  rows={6}
                  multiline
                />
              </Grid>
            </>
          )}

          {get(formBody, 'status') ===
          MISSION_EXPERISE_VICTIM_STATUS.VALIDATED ? (
            <Grid item xs={12}>
              <section>
                {uploadedDocument && (
                  <div className="support-document-info">
                    <Document
                      name={get(uploadedDocument, 'name', '')}
                      type={get(uploadedDocument, 'type', '')}
                      icon={
                        <VisibilityIcon
                          className="consult"
                          onClick={handleOpenDocument(
                            uploadedDocument as any,
                            props.requestGetDocByDocumentumId,
                          )}
                        />
                      }
                    />
                  </div>
                )}
              </section>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Grid item xs={12}>
                {!props.isReadOnly && (
                  <span style={{ fontSize: '13px', color: 'red' }}>
                    {translate({ ...messages.documentStampedTitle }, props)}
                  </span>
                )}
                <UploadDocumentBloc
                  index={0}
                  document={document}
                  resetUploadedDocument={resetUploadDocumentStore}
                  uploadDocument={uploadDocument}
                  uploadedDocument={uploadedDocument}
                  docType={DOCUMENT_TYPES.RAPPORT_CONSEIL}
                  setDocumentId={setDocumentId}
                  docId={documentId}
                  setDocument={setDoc}
                  deleteDoc={
                    !isNil(get(formBody, 'id')) &&
                    (get(formBody, 'status') ===
                      MISSION_EXPERISE_VICTIM_STATUS.PENDING ||
                      get(formBody, 'status') ===
                        MISSION_EXPERISE_VICTIM_STATUS.VALIDATED)
                      ? undefined
                      : props.sagis_code === get(formBody, 'createdBy')
                      ? deleteDoc
                      : undefined
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <div className="error">
                  {documentError?.message[DOCUMENT.NAME]}
                </div>
              </Grid>
            </Grid>
          )}
          {featureService.hasFeature(FEATURES.TRANSACTION) &&
            isTransactionMission(props.mission) && (
              <Grid item xs={12}>
                <ExpertRapportDocument
                  victim={props.victim}
                  expertise={formBody}
                  listings={props.listings}
                  claimNumber={props.claimNumber}
                  lossDate={props.lossDate}
                  mission={props.mission}
                />
              </Grid>
            )}
          {((props.isReadOnly && get(formBody, 'status')) ||
            get(formBody, 'status') ===
              MISSION_EXPERISE_VICTIM_STATUS.REJECTED) && (
            <>
              <Grid item>
                <Typography
                  style={{
                    color: COLORS.LIGHT_GREY,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {translate(messages.statusTitle, props)}
                </Typography>
              </Grid>
              <Grid item xs={11}>
                <Chip
                  style={{
                    backgroundColor: renderColor(get(formBody, 'status')),
                    color: COLORS.WHITE,
                    fontWeight: 700,
                  }}
                  label={renderChipLabel(get(formBody, 'status'))}
                />
              </Grid>
            </>
          )}
          {(props.isReadOnly &&
            get(formBody, 'status') &&
            get(formBody, 'createdBy')) ||
          get(formBody, 'status') ===
            MISSION_EXPERISE_VICTIM_STATUS.REJECTED ? (
            <>
              <Grid item>
                <Typography
                  style={{
                    color: COLORS.LIGHT_GREY,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {translate(messages.createdByTitle, props)}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  style={{
                    color: COLORS.TEXT_BLACK,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {getValueByCode(
                    get(formBody, 'createdBy') as string,
                    get(props.listings, 'intervenants'),
                  )}
                </Typography>
              </Grid>
            </>
          ) : (
            <></>
          )}
          {get(formBody, 'decisionComment') && (
            <>
              <Grid item>
                <Typography
                  style={{
                    color: COLORS.LIGHT_GREY,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {translate(messages.comment, props) + ':'}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{
                    color: COLORS.TEXT_BLACK,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {get(formBody, 'decisionComment')}
                </Typography>
              </Grid>
            </>
          )}
          {get(formBody, 'rejectionReason') &&
            get(formBody, 'status') ===
              MISSION_EXPERISE_VICTIM_STATUS.REJECTED && (
              <>
                <Grid item>
                  <Typography
                    style={{
                      color: COLORS.LIGHT_GREY,
                      fontWeight: 400,
                      fontSize: '13px',
                    }}
                  >
                    {translate(messages.reason, props) + ':'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    style={{
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 400,
                      fontSize: '13px',
                    }}
                  >
                    {get(formBody, 'rejectionReason')}
                  </Typography>
                </Grid>
              </>
            )}
        </StyledGrid>
      </CustomAccordion>
    </>
  );
};

const mapDispatchToProps = {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
};

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(DeceasedVictimForm));
